module.exports = __webpack_public_path__ + "img/greyI.a38ba280.svg";